import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import SceneChangerContext from '../sceneChangerContext';

class SceneChangerLink extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    runAnimation: PropTypes.func.isRequired,
    sceneChangerStore: PropTypes.object.isRequired,
    innerRef: PropTypes.func,
  };

  handleClick(e, onLinkClick) {
    e.preventDefault();

    onLinkClick(this.props.to);

    this.props
      .runAnimation()
      .then(fromAnimation => {
        this.props.sceneChangerStore.handleAnimationEnd(this.props.to, fromAnimation);
      })
      .catch(err => {
        console.log('Error occurred', err);
      });
  }

  render() {
    const { children, to, innerRef, ...rest } = this.props;
    delete rest.sceneChangerStore;
    delete rest.runAnimation;
    delete rest.progressStore;

    return (
      <SceneChangerContext.Consumer>
        {({ onLinkClick }) => (
          <a href={to} ref={innerRef} onClick={e => this.handleClick(e, onLinkClick)} {...rest}>
            {children}
          </a>
        )}
      </SceneChangerContext.Consumer>
    );
  }
}

export default inject(stores => ({
  sceneChangerStore: stores.store.sceneChanger,
}))(observer(SceneChangerLink));



// WEBPACK FOOTER //
// ./src/components/SceneChanger/components/SceneChangerLink.js